/* MBG-98: Stat banner count-up.
   When the banner scrolls into view, animate the number from 0 to its target
   (data-stat-target) over data-stat-duration ms. Honours reduced motion and
   the data-stat-animate="false" opt-out (just shows the final value). */
(function () {
  var banners = document.querySelectorAll('[data-oddit-stat-banner]');
  if (!banners.length) return;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  banners.forEach(function (banner) {
    var numEl = banner.querySelector('[data-stat-number]');
    if (!numEl) return;

    var target = parseFloat(banner.getAttribute('data-stat-target'));
    if (isNaN(target)) return;

    var duration = parseInt(banner.getAttribute('data-stat-duration'), 10) || 1600;
    var animate = banner.getAttribute('data-stat-animate') !== 'false';

    // No animation: leave the final value in place.
    if (!animate || prefersReduced || !('IntersectionObserver' in window)) {
      numEl.textContent = target;
      return;
    }

    numEl.textContent = '0';
    var hasRun = false;

    function runCountUp() {
      var startTime = null;
      function tick(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        // easeOutCubic for a quick-then-settle feel
        var eased = 1 - Math.pow(1 - progress, 3);
        numEl.textContent = Math.round(eased * target);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          numEl.textContent = target;
        }
      }
      requestAnimationFrame(tick);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !hasRun) {
            hasRun = true;
            observer.disconnect();
            runCountUp();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(banner);
  });
})();
